import React, { Component, Fragment } from "react";
//images
import single_line from "../../assets/preLoginUi/single_line.png";
import vector_1 from "../../assets/preLoginUi/vector_1.jpg";
import vector_2 from "../../assets/preLoginUi/vector_2.png";
import vector_3 from "../../assets/preLoginUi/vector_3.png";
import vector_4 from "../../assets/preLoginUi/vector_4.png";

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Fragment>
        <div className="row no-gutters mt-5 justify-content-center">
          <div className="col-10">
            <div className="row justify-content-between">
              <div className="col-lg-5 col-md-7 col-sm-12 mt_150 mt_mob">
                <div className="d-flex flex-column">
                  <div className="flex-row align-item-enter d-md-inline-flex">
                    <a href="">
                      <span className="text_font_1">Unique Services</span>
                      <img src={single_line} alt="images" className="ml-3" />
                    </a>
                  </div>
                  <span className="text_font_2 ft_size_mob">
                    How we
                    <span className="text_font_2 text_clr ft_size_mob"> help <br/>you!</span>
                  </span>
                </div>
                <div className="row mb-3">
                  <div className="col-lg-12 col-sm-12">
                    <span className="text_font_5">
                      A few from our kitty of many unique services
                    </span>
                    {/* <br></br>
                    <span className="text_font_5">
                      so that we can become a favorite company for all
                    </span>
                    <br></br>
                    <span className="text_font_5">companies that use our services</span> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row mb_3">
                  <div className="col-lg-6">
                    <div
                      className="card"
                      style={{
                        height: "105%",
                        //borderRadius: "20px",
                        //border: "2px solid lightgrey",
                        //height: "250px",
                      }}
                    >
                      <img src={single_line} alt="images" className="" />
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3">
                              <img src={vector_1} alt="images" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_5 text_font_6">Research & Insights</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_font_5">
                              {/* Our service is rendered for as long as it is used in your business
                              environment. We will make sure that our products quality does not
                              burden your daily business process. */}
                              Actionable Insights with Research Automation that helps you scale with
                              client success.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card" style={{ height: "105%" }}>
                      <img src={single_line} alt="images" className="" />
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3">
                              <img src={vector_2} alt="images" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_5 text_font_6">Sales Support</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_font_5">
                              {/* Our service is rendered for as long as it is used in your business
                              environment. We will make sure that our products quality does not
                              burden your daily business process. */}
                              We grow as you grow. Leads with strong conversion chances is our
                              promise.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5 mb-3">
                  <div className="col-lg-6">
                    <div className="card" style={{ height: "105%" }}>
                      <img src={single_line} alt="images" className="" />
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3">
                              <img src={vector_3} alt="images" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_5 text_font_6">Multi Products</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_font_5">
                              {/* Our service is rendered for as long as it is used in your business
                              environment. We will make sure that our products quality does not
                              burden your daily business process. */}
                              That fits into every aspect of your client’s personal financial
                              journey.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card" style={{ height: "105%" }}>
                      <img src={single_line} alt="images" className="" />
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <div className="mb-3">
                              <img src={vector_4} alt="images" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_5 text_font_6">Robo Advisory</p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <p className="text_font_5">
                              {/* Our service is rendered for as long as it is used in your business
                              environment. We will make sure that our products quality does not
                              burden your daily business process. */}
                              With a human touch. The true Hybrid Model that you had been waiting
                              for
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Company;
